import { memo } from 'react'

import { ListItemProps } from './list-item.model'
import * as S from './styles'

interface UnorderedListProps {
  items: ListItemProps[]
}

export const UnorderedList = memo(({ items } : UnorderedListProps) => (
  <S.UnorderedList>
    {items.map(({ id, content }) => (
      <S.ListItem key={id}>{content}</S.ListItem>
    ))}
  </S.UnorderedList>
))

UnorderedList.displayName = 'UnorderedList'
